<template>
  <v-card elevation="0">
    <v-card-title class="pt-4 pb-0 accent--text text--lighten-1">
      <div>
        <label class="title">{{ device.name }}</label>
        <p>{{ device.code }}</p>
      </div>
    </v-card-title>
    <v-card-text class="mt-0 accent--text">
      <v-layout wrap justify-center>
        <v-flex shrink>
          <label>Peso total</label>
          <p class="display-4">
            {{ weight || 0 | formatWeight }}
            <sub>t</sub>
          </p>
        </v-flex>
        <v-flex shrink>
          <p class="display-1 pl-5">
            {{ averageSpeed || 0 | formatSpeed }} <sub>toneladas/hora</sub>
          </p>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-space-around mt-5>
        <v-flex shrink>
          <label>Tiempo inactivo</label>
          <p class="display-2">{{ readings.inactive || 0 | formatReading }}</p>
        </v-flex>
        <v-flex shrink>
          <label>Tiempo activo</label>
          <p class="display-2">{{ readings.active || 0 | formatReading }}</p>
        </v-flex>
        <v-flex shrink>
          <label>Tiempo error</label>
          <p class="display-2">{{ readings.errors || 0 | formatReading }}</p>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center mt-5>
        <v-flex sm12 md8 lg6>
          <v-select
            flat
            v-model="material"
            :items="materials"
            label="Materia Prima"
            item-value="code"
            item-text="name"
            required
            :disabled="loading || active"
            :error-messages="errors.material"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="justify-center">
      <v-btn
        color="accent"
        depressed
        large
        :disabled="loading || active"
        @click="zero()"
      >TARA</v-btn>
      <v-btn color="accent" depressed large :disabled="loading || active" @click="start()">INICIAR</v-btn>
      <v-btn color="accent" depressed large :disabled="loading || !active" @click="stop()">DETENER</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

import api from '@/api/app'

import mutationsMixin from '@/mixins/mutationsMixin'

export default {
  name: 'Device',
  mixins: [mutationsMixin],
  beforeDestroy () {
    this.unsubscribe(this.topic)
  },
  beforeMount () {
    this.loading = true

    this.topic = `com/alumisel/sensor/${this.$route.params.id}`

    api.getDevice(this.$route.params.id).then(response => {
      this.device = response
      this.getInfo()
      this.$store.state.pageTitle = 'Dispositivos | ' + this.device.code
      this.subscribe({
        topic: this.topic,
        onMessage: this.onMessage
      })
    })

    api.getRawMaterials().then(response => {
      this.materials = response
    })
  },
  data () {
    return {
      loading: false,
      material: null,
      materials: [],
      device: {},
      errors: {},
      averageSpeed: null,
      status: null,
      weight: null,
      readings: {},
      topic: null
    }
  },
  computed: {
    active () {
      return this.status === 'active'
    }
  },
  methods: {
    ...mapActions(['subscribe', 'unsubscribe']),
    getInfo () {
      api.getDeviceInfo(this.device.id).then(response => {
        this.loading = false
        this.apply(response)
      }).catch(this.deviceError)
    },
    deviceError () {
      this.loading = false
      this.error('Error de comunicación con el dispositivo')
    },
    start () {
      if (!this.material) {
        this.errors = {material: ['Este campo es requerido']}
        return
      }
      this.errors = {}
      this.loading = true
      api.startDevice(this.device.id, { material: this.material }).catch(this.deviceError)
    },
    stop () {
      api.stopDevice(this.device.id).then(response => {
        this.getInfo()
      }).catch(this.deviceError)
    },
    zero () {
      api.zeroDevice(this.device.id).then(response => {
        this.success('TARA aplicada')
      }).catch(this.deviceError)
    },
    onMessage (message) {
      if (this.loading) {
        this.loading = false
      }
      this.apply(message.data)
    },
    apply (data) {
      if (!data.measurement) return
      this.status = data.measurement.status
      this.averageSpeed = data.measurement.speed
      this.weight = data.measurement.weight
      this.readings = data.measurement.readings || {}

      if (this.active) {
        this.material = data.measurement.material
      }
    }
  },
  filters: {
    formatWeight (number) {
      let decimals = 4
      let digits = 7
      var units = Math.round(number / 1000 * Math.pow(10, decimals))
      var padded = units.toString().padStart(digits, '0')
      return `${padded.slice(0, -decimals)}.${padded.slice(-decimals)}`
    },
    formatSpeed (number) {
      if (!number) return null
      return parseFloat(number / 1000).toFixed(4)
    },
    formatReading (number) {
      let minutes = Math.trunc(number / 600)
      let seconds = Math.trunc((number % 600) / 10)
      let miliseconds = Math.trunc((number % 600) % 10)
      let padded = seconds.toString().padStart(2, 0)
      return `${minutes}:${padded}.${miliseconds}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Device.vue